import { render } from "./ChatForm.vue?vue&type=template&id=be5846ae&scoped=true"
import script from "./ChatForm.vue?vue&type=script&lang=ts"
export * from "./ChatForm.vue?vue&type=script&lang=ts"

import "./ChatForm.vue?vue&type=style&index=0&id=be5846ae&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-be5846ae"

export default script